/* ============================================================
   PALAMANO — El panel del menú, alineado con su palabra

   En on.com el contenido del panel empieza justo donde empieza la
   palabra que lo abre. Esa posición depende del ancho de la ventana
   —el menú va centrado— así que no se puede dejar fija en el CSS.

   ⚠️ Se mide ANTES de abrir, no al abrir: si se midiera al abrir, el
   panel aparecería en la posición de reserva y daría un salto al
   colocarse. Por eso se deja puesta de entrada en todos los paneles.
   ============================================================ */
(() => {
  const alinear = () => {
    document.querySelectorAll('header-dropdown-menu').forEach((panel) => {
      const enlace = panel.closest('li')?.querySelector(':scope > a');
      if (!enlace) return;

      const x = Math.round(enlace.getBoundingClientRect().left);
      if (x > 0) panel.style.setProperty('--pmn-menu-x', `${x}px`);
    });
  };

  const alCargar = () => {
    alinear();
    /* Las tipografías cambian el ancho de los enlaces al terminar de
       cargar, y con ello su posición. */
    document.fonts?.ready.then(alinear);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alCargar);
  } else {
    alCargar();
  }

  /* El estado del menú, marcado en <html>.

     Antes el CSS lo averiguaba solo con `body:has(header-dropdown-menu[open])`.
     Funcionaba, pero obliga al navegador a recalcular el estilo del documento
     entero cada vez que el menú abre o cierra, y ese trabajo se vuelve visible
     como un parpadeo de todo el panel a partir de la segunda vez. Una clase
     sale prácticamente gratis. */
  const marcarEstado = () => {
    const abierto = !!document.querySelector('header-dropdown-menu[open]');
    document.documentElement.classList.toggle('pmn-menu-abierto', abierto);
  };

  new MutationObserver(marcarEstado).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['open'],
  });

  window.addEventListener('resize', alinear);
  window.addEventListener('load', alinear);

  /* Y por si el header se vuelve a dibujar (cambio de sección en el
     editor del tema, navegación sin recarga…). */
  new MutationObserver(alinear).observe(document.documentElement, {
    subtree: true,
    childList: true,
  });
})();
